
import * as React from 'react';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { Fabric } from 'office-ui-fabric-react/lib/Fabric';
import { IItemCacheThunkAction } from '../../store/actions/ItemCacheActions';
import { createInitializer, ItemsScope } from '../itemsScope/ItemsScope';
import { fileEntryAddon } from '../../operations/uploadItems/FileEntryAddon';
import { ItemsBreadcrumb } from '../itemsBreadcrumb/ItemsBreadcrumb';
import { ItemsView } from '../itemsView/ItemsView';
import { DetailsLayout } from '../layouts/DetailsLayout';
import { fileTypeIconColumn } from '../columns/fileTypeIcon/fileTypeIconColumn';
import { displayNameColumn } from '../columns/displayName/displayNameColumn';
import { dateModifiedColumn } from '../columns/dateModified/dateModifiedColumn';
import { fileSizeColumn } from '../columns/fileSize/fileSizeColumn';

const COLUMNS = [
  fileTypeIconColumn,
  displayNameColumn,
  dateModifiedColumn,
  fileSizeColumn
];

/**
 * @internal
 */
export interface IFileEntryPanelProps {
  entryBatchKey: string;
  onDismiss?: () => void;
}

/**
 * @internal
 */
export interface IFileEntryPanelState {
  initializer: (payload: { itemsScopeItemKey: string; }) => IItemCacheThunkAction<void>;
}

/**
 * @internal
 */
export class FileEntryPanel extends React.PureComponent<IFileEntryPanelProps, IFileEntryPanelState> {
  constructor(props: IFileEntryPanelProps) {
    super(props);

    this.state = {
      initializer: createInitializer(fileEntryAddon, this.props.entryBatchKey)
    };
  }
  public render(): JSX.Element {
    return (
      <Panel
        headerText='Upload'
        isOpen={ true }
        onDismiss={ this._onDismissDialog }
        type={ PanelType.large }
      >
        <Fabric>
          <ItemsScope initializer={ this.state.initializer }>
            <ItemsBreadcrumb />
            <ItemsView>
              <DetailsLayout columns={ COLUMNS } />
            </ItemsView>
          </ItemsScope>
        </Fabric>
      </Panel>
    );
  }

  private _onDismissDialog(): void {
    const {
      onDismiss
    } = this.props;

    if (onDismiss) {
      onDismiss();
    }
  }
}
